import { render, staticRenderFns } from "./PageAssetCreate.vue?vue&type=template&id=7a7762a8&"
import script from "./PageAssetCreate.vue?vue&type=script&lang=js&"
export * from "./PageAssetCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports